// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9f_0u","importantInfo":"styles_importantInfo__1YLjW"};